{{ normalizedValue() }} <span *ngIf="uom()">{{ uom() }}</span>
